import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  padding: 50px;
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;

  button {
    border: none;
    outline: none;
    background: transparent;
    margin-top: -15px;
    color: var(--fern);
  }
`;
